<template>
  <div class="error-page">
    <div class="error-page__img">
      <img src="@/assets/errors/error_404.png" alt="error-page-bg" />
    </div>

    <h1 class="error-page__title">{{ $t('responseErrors.errors_happens') }}</h1>
    <p class="error-page__subtitle">
      {{ $t('responseErrors.deleted_page') }}
    </p>
    <b-button
      class="error-page__button"
      rounded
      type="is-success"
      @click="goToMain"
      >{{ $t('responseErrors.go_to_main') }}</b-button
    >
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PageNotFoundView',
  computed: {
    ...mapState({
      manager: (state) => state.manager.manager,
    }),
  },
  methods: {
    goToMain() {
      if (this.manager !== null) {
        this.$router.push({ name: 'main' })
      } else {
        this.$router.push({ name: 'landing' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  background-image: url('@/assets/errors/error_page_bg.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;
  padding: 25px 0;
  @media (max-width: $mobile-width) {
    min-height: 300px;
    padding: 25px 15px;
  }
  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 250px;
    @media (max-width: $mobile-width) {
      min-width: 150px;
    }
  }
  &__title {
    max-width: 700px;
    text-align: center;
    @media (max-width: $mobile-width) {
      font-size: 25px;
    }
  }
  &__subtitle {
    margin: 10px 0;
    text-align: center;
  }
  &__button {
    margin-top: 20px;
  }
}
</style>
